import Config from '@configs/Environments';
import useAxios from 'axios-hooks';

const path = Config.API_END_POINT + '/entry/abolitions/';

const useAllListData = (id:string): any => {
    const [{ data, loading, error }] = useAxios(`${path}${id}`, {useCache: false});
    return { data, loading, error };
};

const useCloseRequest = {
    useAllListData,
};

export default useCloseRequest;